import { Checkbox, type CheckboxProps } from '@progress/kendo-react-inputs'
import React from 'react'
import { useTranslation } from 'react-i18next'

export type ExpandTextToggleFormProps = {
  isTextExpanded?: boolean
  onChange?: (isExpanded: boolean) => void
}

export const ExpandTextToggleForm = ({
  isTextExpanded,
  onChange,
}: ExpandTextToggleFormProps) => {
  const { t } = useTranslation()
  const handleChange = React.useCallback<EH<CheckboxProps, 'onChange'>>(
    (event) => {
      onChange?.(event.value)
    },
    [onChange],
  )

  return (
    <Checkbox
      checked={isTextExpanded}
      label={t('show_full_text')}
      onChange={handleChange}
    />
  )
}
